<script setup>
import { formatDistanceToNow } from 'date-fns'; // npm install date-fns
import NotificationIcon from './NotificationIcon.vue';
import { cn } from '@/lib/utils'; // Shadcn utility

const props = defineProps({
  notification: { type: Object, required: true }
});

const emit = defineEmits(['click']);

// Determine colors based on variant
const variantStyles = {
  success: 'text-green-600 bg-green-100 dark:bg-green-900/30 dark:text-green-400',
  warning: 'text-yellow-600 bg-yellow-100 dark:bg-yellow-900/30 dark:text-yellow-400',
  error:   'text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400',
  info:    'text-blue-600 bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400',
  default: 'text-foreground bg-muted',
};

const isUnread = !props.notification.read_at;
</script>

<template>
  <div :class="cn( 'flex items-start gap-3 p-4 cursor-pointer transition-colors hover:bg-muted/50 relative group', isUnread ? 'bg-muted/30' : 'opacity-80')" @click="$emit('click', notification)">
    <div v-if="isUnread" class="absolute right-3 top-4 h-2 w-2 rounded-full bg-blue-500" />
    <div :class="cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-full', variantStyles[notification.data.variant] || variantStyles.default)">
      <NotificationIcon
        :name="notification.data.icon"
        :pack="notification.data.icon_pack"
      />
    </div>

    <div class="grid gap-1">
      <p class="text-sm font-medium leading-none">
        {{ notification.data.title }}
      </p>
      <p class="text-sm text-muted-foreground line-clamp-2">
        {{ notification.data.message }}
      </p>
      <p class="text-xs text-muted-foreground mt-1">
        {{ formatDistanceToNow(new Date(notification.created_at), { addSuffix: true }) }}
      </p>
    </div>
  </div>
</template>
